<template>
  <v-row
    align="center"
    justify="center"
    class="benefits"
  >
    <v-col
      cols="12"
      md="6"
      class="position-relative"
    >
      <div class="img-shadow-wrap">
        <v-img
          :src="require('@/assets/images/stop-wasting-time.webp')"
          aspect-ratio="1"
          class="rounded-image"
          contain
          alt="stop-wasting-time"
        />
      </div>
    </v-col>

    <v-col cols="12" md="6">
      <SectionTitle>Com o ZaperMenu você:</SectionTitle>

      <ul class="benefits-list mt-8">
        <li
          v-for="(item, i) in benefits"
          :key="i"
          class="benefit-item"
          :style="{ animationDelay: `${i * 0.12}s` }"
        >
          <div class="benefit-icon-wrap">
            <v-icon color="success" size="18">mdi-check</v-icon>
          </div>
          <span>{{ item }}</span>
        </li>
      </ul>
    </v-col>
  </v-row>
</template>

<script>
  import SectionTitle from "@/components/SectionTitle.vue";

  export default {
    name: "BenefitsSection",

    components: {
      SectionTitle,
    },

    data: () => ({
      benefits: [
        'Não deixa seus clientes esperando para serem atendidos',
        'Recebe os pedidos prontos sem falar com os clientes',
        'Tem impressão automática de pedidos',
        'Envia o pedido no WhatsApp do motoboy com localização',
        'Aumenta o ticket médio e faturamento',
      ],
    }),
  };
</script>

<style scoped lang="scss">
  .benefits {
    @media (max-width: 768px) {
      flex-direction: column-reverse;
    }
  }

  /* Lista */
  .benefits-list {
    list-style: none;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  /* Card de cada item */
  .benefit-item {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 14px 18px;
    border-radius: 14px;
    background: var(--card-bg);
    border: 1px solid var(--card-border);
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    color: var(--text-secondary);

    /* Entrada escalonada */
    opacity: 0;
    animation: benefit-appear 0.45s ease-out forwards;

    /* Hover sutil */
    transition: border-color 0.25s, transform 0.25s;
    &:hover {
      border-color: rgba(35, 207, 101, 0.5);
      transform: translateX(4px);
    }

    @media (max-width: 768px) {
      font-size: 15px;
      padding: 12px 14px;
    }
  }

  /* Círculo com ícone */
  .benefit-icon-wrap {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(35, 207, 101, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .img-shadow-wrap {
    border-radius: 20px;
    overflow: hidden;
  }

  @keyframes benefit-appear {
    from {
      opacity: 0;
      transform: translateX(-18px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
</style>
